import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

type RouteTitle = [string | RegExp, string];

const ROUTE_TITLES: RouteTitle[] = [
    // Auth
    ['/login', 'Sign In'],
    ['/forgotPassword', 'Forgot Password'],
    ['/resetPassword/', 'Reset Password'],
    // Admin — more specific prefixes first
    ['/admin/orders/details/', 'Order Details'],
    ['/admin/orders', 'Orders'],
    ['/admin/upceditor', 'UPC Editor'],
    ['/admin/vertical/', 'Vertical Details'],
    ['/admin/category/', 'Category Details'],
    ['/admin/subcategory/', 'Subcategory Details'],
    ['/admin/invoices', 'Invoices'],
    ['/admin/agency-fee-summary', 'Agency Fee Summary'],
    ['/admin/promotioncodes', 'Promotion Codes'],
    ['/admin/notifications', 'Push Notifications'],
    ['/admin/subscriptions', 'Subscriptions'],
    ['/admin/subscription/merchant/', 'Merchant Subscription'],
    ['/admin/subscription/pro/', 'Pro Subscription'],
    ['/admin/tk-pro-teams', 'TK Pro Teams'],
    ['/admin/pro/', 'Pro Organisation'],
    // /admin/merchant/:merchantId/shop/:id must come before /admin/merchant/:id
    [/^\/admin\/merchant\/[^/]+\/shop\//, 'Shop Details'],
    ['/admin/merchants', 'Merchants'],
    ['/admin/merchant/', 'Merchant Details'],
    // Merchant — more specific first
    ['/merchant/orders/details/', 'Order Details'],
    ['/merchant/orders', 'Orders'],
    ['/merchant/privacy-policy/', 'Privacy Policy'],
    // Shared / Shop — more specific first
    ['/orders/details/', 'Order Details'],
    ['/orders', 'Orders'],
    ['/invoices', 'Invoices'],
    ['/agency-fee-summary', 'Agency Fee Summary'],
    ['/subscription', 'Subscription'],
    ['/returns', 'Returns'],
    // Collection — /delivery-order/ before /delivery-orders
    ['/delivery-order/', 'Delivery Order Details'],
    ['/delivery-orders', 'Delivery Orders'],
    ['/new-delivery-order', 'New Delivery Order'],
    ['/delivery-dashboard', 'Delivery Dashboard'],
];

const DEFAULT_TITLE = 'TradeKart - Portal';

export default function PageTitle() {
    const { pathname } = useLocation();

    useEffect(() => {
        const match = ROUTE_TITLES.find(([prefix]) =>
            typeof prefix === 'string' ? pathname.startsWith(prefix) : prefix.test(pathname)
        );
        document.title = (match ? match[1] + ' | ' : '') + DEFAULT_TITLE;
    }, [pathname]);

    return null;
}
